import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip';

const STORAGE_KEY = 'spooker_show_page_tooltips';

export const getTooltipPref = () => {
  try {
    const val = localStorage.getItem(STORAGE_KEY);
    return val === null ? true : val === 'true';
  } catch { return true; }
};

export const setTooltipPref = (val) => {
  localStorage.setItem(STORAGE_KEY, String(val));
};

const PageHeader = ({ title, subtitle, tooltip, children, testId }) => {
  const showTooltips = getTooltipPref();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <div className="flex items-center gap-2">
          <h1
            className="text-2xl font-bold tracking-tight text-black dark:text-white"
            data-testid={testId || 'page-title'}
          >
            {title}
          </h1>
          {showTooltips && tooltip && (
            <TooltipProvider delayDuration={200}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <button className="text-neutral-400 hover:text-neutral-600 transition-colors" data-testid="page-title-tooltip-trigger">
                    <Info className="h-4 w-4" strokeWidth={1.5} />
                  </button>
                </TooltipTrigger>
                <TooltipContent side="right" className="max-w-xs text-xs leading-relaxed">
                  {tooltip}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
        {subtitle && (
          <p className="text-sm text-neutral-500 mt-1">{subtitle}</p>
        )}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
};

export default PageHeader;
